"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var apply_extension_spec_1 = __importDefault(require("./apply-extension-spec"));
var get_extended_metaschema_1 = __importDefault(require("./get-extended-metaschema"));
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function getDocumentExtendedMetaSchema(document) {
    var extendedMetaSchema = (0, get_extended_metaschema_1.default)();
    var extendedDocument = (0, apply_extension_spec_1.default)(document, extendedMetaSchema);
    return extendedDocument;
}
exports.default = getDocumentExtendedMetaSchema;
